import React, { useContext, useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import SupplierContext from "context/SupplierContext";
import { Swiper, SwiperSlide } from "swiper/react";
//import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import "swiper/css";
import "swiper/css/navigation";
import { BiMinus } from "react-icons/bi";
import { BsPlus, BsTrash } from "react-icons/bs";
import { Navigation, Pagination } from "swiper";
import "./SingleProduct.scss";
import { connection } from "../../utils/apiConnection.ts";
import numberWithCommas from "../common/numberWithCommas";
import Comments from "./Comments";
import { addCommas } from "@persian-tools/persian-tools";
import toast from "react-hot-toast";
import EditProductModal from "./EditProductModal.jsx";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";
import sabadLog from "../../assets/images/logo-sabadi.png";
import Rate from "rc-rate";
import "rc-rate/assets/index.css";
import CartItemsContext from "context/ShoppingCartItems";
import Loader from "utils/Loader";
import { useParams } from "react-router-dom";
import SinglePartitionNew from "./singlePartitionNew";
import Formatter from "hoc/Formatter";
import { TbBasket } from "react-icons/tb";
import { SiTeradata } from "react-icons/si";

const SingleProduct = ({
  updater1,
  setUpdater1,
  // data,
  type,
}) => {
  let param = useParams();
  const {
    shoppingData,
    updateShoppingList,
    currentInventory,
    prices,
    setPrices,
    itemsCount,
    itemsId,
    getCount,
    isLoading,
    setIsLoading,
  } = useContext(CartItemsContext);
  console.log(setUpdater1, "setUpajshdgkfhkahsfgkdhdater1");
  const { isLogged, userInfo } = useContext(AuthenticationContext);
  const { product, setProduct } = useContext(SupplierContext);
  const [data, setData] = useState([]);
  const [amount, setAmount] = useState("");
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [selectedAoos, setSelectedAoos] = useState([]);
  const [selectedAoosPrice, setSelectedAoosPrice] = useState(0);
  // console.log("product", product);
  const [sendComment, setSendComment] = useState({
    rating: "",
    txt: "",
    product_id: "",
  });
  const [commentUpdater, setCommentUpdater] = useState(true);
  console.log("pr", product);

  // console.log("selectedIndex", selectedIndex);

  // useEffect(() => {
  //   setAmount("0");
  // }, [product]);
  const [comments, setComments] = useState([]);
  const [similarProductShouldChange, setSimilarProductShouldChange] =
    useState(true);
  useEffect(() => {
    if (product) {
      setSelectedAoos(JSON.parse(product.info.selected_aoos));
      setSelectedAoosPrice(product.info.price);
      let pro = { ...product };
      let temp = { ...product.info },
        flag = false;
      // if (typeof selectedProduct.info !== "undefined") {
      //   temp = { ...selectedProduct.info };
      // }
      if (
        temp.product_cover_img != "" &&
        !temp.product_cover_img.includes("http")
      ) {
        temp.product_cover_img = `http://sabadi.tatdemo.ir/${temp.product_cover_img}`;
        flag = true;
      }
      if (
        temp.supplier_cover_img != "" &&
        !temp.supplier_cover_img.includes("http")
      ) {
        temp.supplier_cover_img = `http://sabadi.tatdemo.ir/${temp.supplier_cover_img}`;
        flag = true;
      }
      if (flag) {
        pro.info = { ...temp };
        setProduct({ ...pro });
      }

      // console.log(pro);
    }
    console.log("similarProductShouldChange", similarProductShouldChange);
    if (similarProductShouldChange) {
      console.log("run?");
      connection("api/get_similar_products", {
        title: product?.info.title,
        avb_product_id: product?.info.product_id,
      }).then((data) => {
        setData(data.data);
      });
    }
  }, [product]);

  const addCart = () => {
    if (amount == "") {
      toast.error("لطفا تعداد را وارد کنید!");
    } else if (+amount < +product.info.min_order_count) {
      toast.error("تعداد نمی تواند از حداقل سفارش کمتر باشد!!!");
    } else {
      connection("api/addcartitem", {
        productForOrderId: product.info.avb_product_for_order__id,
        count: amount,
        price: product.info.price,
      }).then((data) => {
        if (data.status == 1) {
          toast.success("به سبد خرید اضافه شد");
          updateShoppingList();
          setAmount("");
          document.querySelector("#singleproduct .btn-close").click();
        } else {
          toast.error("مشکلی در افزودن کالا به سبد خریدتان به وجود آمده!!!");
        }
      });
    }
  };
  // rating
  const changeHandler = (value, type) => {
    setSendComment((prev) => {
      return { ...prev, [type]: value };
    });
    // console.log("send comment : ", sendComment);
  };
  const changeHandlerJson = (value, names, index) => {
    let array = [...selectedAoos];
    array[index] = { ...array[index], [names]: value };
    setSelectedAoos(array);
  };
  const totalPrice = () => {
    let temp = 0;
    let price = product.info.price;
    for (let i = 0; i < selectedAoos.length; i++) {
      if (selectedAoos[i].status == false) {
        temp += parseInt(selectedAoos[i].default_price);
      }
    }
    return parseInt(price) + parseInt(temp);
    setSelectedAoosPrice(() => parseInt(price) + parseInt(temp));
  };
  const addCartItem = (type, id, count, price) => {
    setIsLoading(true);
    let temp = { count: count, price: price };
    if (type == "basket") {
      temp = { ...temp, basketId: id };
    } else if (type == "product") {
      temp = { ...temp, productForOrderId: id };
    }
    connection("api/addcartitem", temp).then((data) => {
      if (data.status == 1) {
        toast.success("کالا با موفقیت به سبد خرید شما اضافه شد.");
        updateShoppingList();
        // setIsLoading(false);
      } else {
        toast.error("در حال حاضر امکان افزودن کالا وجود ندارد.");
        setIsLoading(false);
      }
    });
  };
  const reduceCartItem = (type, id) => {
    setIsLoading(true);
    let temp = {};
    if (type == "basket") {
      temp = { ...temp, basketId: id };
    } else if (type == "product") {
      temp = { ...temp, productForOrderId: id };
    }
    connection("api/reducecartitems", temp).then((data) => {
      if (data.status == 1) {
        toast.success("کالا با موفقیت از سبد خرید شما کم شد.");
        updateShoppingList();
        // setIsLoading(false);
      } else {
        toast.error("در حال حاضر امکان کم کردن کالا وجود ندارد.");
        setIsLoading(false);
      }
    });
  };
  useEffect(() => {
    connection("api/get_comments", {
      product_id: product ? product.info.avb_product_for_order__id : "",
      supplier_id: param.supplier_id,
    }).then((data) => {
      setComments(data.data);

      // console.log("test comment", comments);
    });
  }, [product]);

  // connection("api/get_comments", fd).then(data => {
  //   setComments(data.data);
  // });
  // }, [commentUpdater, selectedBasket]);
  const insertComment = () => {
    if (isLogged) {
      if (sendComment.txt != "") {
        connection("api/Insert_comments", {
          product_id: product.info.product_id,
          supplier_id: product.info.supplier_id,
          muid: userInfo.id,
          apfo_id: product.info.avb_product_for_order__id,
          comment_txt: sendComment.txt,
          mtm: Date.now().toString().slice(0, -3),
          apfo_rate: sendComment.rating,
        }).then((data) => {
          if (data.status == 1) {
            toast.success("نظرتان با موفقیت ثبت شد");
          }
        });
        setSendComment({
          rating: "",
          txt: "",
          // product_id: ""
        });
        setCommentUpdater((prev) => {
          return !prev;
        });
      } else {
        toast.error("نظرتان را در مورد کالا بنویسید");
      }
    } else {
      toast.error("ابتدا وارد حساب کاربری خود شوید");
    }
  };
  const weight = (from_weight, to_weight) => {
    let from =
      from_weight > 1000 ? (
        <span className="text-danger">{from_weight / 1000}کیلوگرم</span>
      ) : (
        <span className="text-danger">{from_weight}گرم</span>
      );
    let to =
      to_weight > 1000 ? (
        <span className="text-danger"> {to_weight / 1000}کیلوگرم </span>
      ) : (
        <span className="text-danger"> {to_weight}گرم </span>
      );

    return (
      <div>
        {" "}
        وزن کالا از {from} &nbsp; تا {to}&nbsp; توسط عرضه کننده تعیین شده است در
        صورتیکه وزن کالا کمتر از {to}&nbsp; باشد، مبلغ مابه التفاوت به کیف پول
        شما <span className="text-danger">باز خواهد گشت.</span>
      </div>
    );
  };
  // console.log("itemsId", itemsId);
  // console.log("product=>", product, "itemsId=>", itemsId);
  // console.log("isLoading", isLoading);
  // console.log("Slcaoos", selectedAoos);
  return (
    <>
      <div
        className="modal fade"
        id="singleproduct"
        tabIndex="-1"
        aria-labelledby="singleproductLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen singleproduct">
          <div className="modal-content">
            {product ? (
              <>
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                {isLoading && <Loader />}
                <div
                  className="modal-body "
                  style={{ padding: " 100px 6% 20px" }}
                >
                  {isLogged &&
                    userInfo.supplier_list.includes(
                      product.info.supplier_id.toString()
                    ) && (
                      <div className="mx-3 mb-2">
                        <button
                          className="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#editProductModal"
                          data-bs-dismiss="modal"
                          // key={index}
                          // onClick={e => setProduct(value)}
                        >
                          ویرایش کالا
                        </button>
                        {ReactDOM.createPortal(
                          <>
                            <EditProductModal
                              // product={product}
                              product={product}
                              setProduct={setProduct}
                              setUpdater1={setUpdater1}
                              updater1={updater1}
                            />
                          </>,
                          document.getElementById("modals")
                        )}
                        {/* <EditProductModal /> */}
                      </div>
                    )}

                  <div className="d-flex align-items-center mx-3 mb-2">
                    {/* <div className="rounded-pill bg-light p-3 "> */}
                    {product.supplier_info[0].path ? (
                      <img
                        src={`http://sabadi.tatdemo.ir/${product.supplier_info[0].path}`}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "25px",
                        }}
                      />
                    ) : (
                      <img
                        src={sabadLog}
                        style={{ width: "50px", height: "50px" }}
                      />
                    )}

                    {/* </div> */}
                    <div className="d-flex mx-2">
                      <h6 className="fs-14">نام فروشگاه : </h6>
                      <h6 className=" mx-1 fs-14">
                        {product.supplier_info[0].title}
                      </h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-4 ">
                      <Swiper
                        navigation={true}
                        modules={[Navigation, Pagination]}
                        slidesPerView={1}
                        pagination={{
                          clickable: true,
                        }}
                        className="mySwiper card product"
                        style={{ maxWidth: "250px", textAlign: "right" }}
                      >
                        {product.info.product_cover_img != "" && (
                          <SwiperSlide>
                            <img src={product.info.product_cover_img} />
                          </SwiperSlide>
                        )}
                        {product.info.supplier_cover_img !== "" && (
                          <SwiperSlide>
                            <img src={product.info.supplier_cover_img}></img>
                          </SwiperSlide>
                        )}
                      </Swiper>
                      {product.info.product_cover_img == "" &&
                        product.info.supplier_cover_img == "" && (
                          <img src={sabadLog} />
                        )}
                    </div>
                    <div className="col-12 col-md-8 description mt-3 px-2">
                      <div className="d-flex flex-wrap">
                        <div className="sp-txt">{product.info.title}</div>
                        {product.info.weight_from != "0" &&
                          product.info.weight_to != "0" && (
                            <div
                              style={{ fontSize: 14, textAlign: "justify" }}
                              className=" d-flex  "
                            >
                              <div className="col-12 col-lg-11  p-2 attention">
                                {weight(
                                  product.info.weight_from,
                                  product.info.weight_to
                                )}
                              </div>
                            </div>
                          )}
                      </div>
                      {product.info.min_order_count != "0" && (
                        <div className="mt-3">
                          <span className="sp-txt" style={{ color: "#F0162E" }}>
                            حداقل سفارش :{" "}
                          </span>
                          <span className="sp-txt">
                            {product.info.min_order_count} عدد{" "}
                          </span>
                        </div>
                      )}
                      {/* <div className="amount mt-2">
                        <span className="sp-txt">
                          مقدار سفارش مورد نظر را وارد کنید.
                        </span>
                        <input
                          type="number"
                          placeholder={1}
                          defaultValue={1}
                          value={amount}
                          onChange={(e) => {
                            if (
                              +e.target.value >= 0 &&
                              +e.target.value <=
                                +product.info.total_inventory_count -
                                  +product.info.complate_inventory_count -
                                  +product.info.frozen_inventory_count
                            ) {
                              setAmount(e.target.value);
                            } else {
                              toast.error(
                                `امکان سفارش کالا بیشتر از تعداد ${
                                  +product.info.total_inventory_count -
                                  +product.info.complate_inventory_count -
                                  +product.info.frozen_inventory_count
                                } وجود ندارد`
                              );
                            }
                          }}
                        />
                      </div> */}

                      {
                        <div>
                          {selectedAoos.map((value, index) => {
                            return (
                              <div className="form-check mt-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="charkhkarde"
                                  checked={
                                    selectedAoos[index].status == false
                                      ? true
                                      : false
                                  }
                                  onClick={(e) => {
                                    changeHandlerJson(
                                      !value.status,
                                      "status",
                                      index
                                    );

                                    // console.log("selectedaoos", value);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="charkhkarde"
                                >
                                  {value.title}
                                </label>
                                <span>
                                  <label
                                    className="form-check-label"
                                    htmlFor="charkhkarde"
                                  >
                                    {addCommas(value.default_price)} تومان
                                  </label>
                                </span>
                                <span>
                                  <label
                                    className="form-check-label"
                                    htmlFor="charkhkarde"
                                  >
                                    {Math.round(value.default_need_time / 60)}
                                  </label>
                                  <label
                                    className="form-check-label"
                                    htmlFor="charkhkarde"
                                  >
                                    دقیقه
                                  </label>
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      }

                      {/* {console.log(
                        "product.info",
                        JSON.parse(product.info.selected_aoos)[selectedIndex]
                          ?.default_price
                      )} */}
                      <div className="total mt-2 d-flex">
                        <div style={{ whiteSpace: "nowrap" }}>قیمت کل : </div>
                        {selectedAoos.length > 0 ? (
                          <span
                            style={{ color: "#F0162E", whiteSpace: "nowrap" }}
                          >
                            {addCommas(totalPrice())}
                            {/* {addCommas(
                              parseInt(product.info.price) +
                                parseInt(
                                  JSON.parse(product?.info.selected_aoos)[
                                    selectedIndex
                                  ]?.default_price
                                )
                            )} */}
                            تومان
                          </span>
                        ) : (
                          <span
                            style={{ color: "#F0162E", whiteSpace: "nowrap" }}
                          >
                            {addCommas(product.info.price)} تومان
                          </span>
                        )}
                      </div>
                      <div>
                        <label className="">قیمت کالا با تخفیف :</label>
                        <span>
                          {addCommas(totalPrice() - product.info.discount)}{" "}
                          تومان
                        </span>
                      </div>
                      <div
                        className={` text-end mt-3 d-flex align-items-center`}
                      >
                        {getCount(
                          product.info.avb_product_for_order__id,
                          "product"
                        ) == "0" ? (
                          <button
                            className={` btn text-light cartBtn shadow rounded  d-flex justify-content-center align-items-center`}
                            // onClick={onInc}
                            onClick={() => {
                              addCartItem(
                                "product",
                                product.info.avb_product_for_order__id,
                                product.info.min_order_count == "0"
                                  ? 1
                                  : product.info.min_order_count,
                                product.info.price
                              );
                            }}
                          >
                            <TbBasket
                              color="red"
                              style={{ fontSize: "25px" }}
                              className="icon"
                            />
                            <span style={{ color: "red" }}>
                              {" "}
                              افزودن به سبد خرید
                            </span>
                          </button>
                        ) : (
                          <>
                            <button
                              className={` btn text-light cartBtn shadow rounded  d-flex justify-content-center align-items-center`}
                              // onClick={onInc}
                              onClick={() => {
                                addCartItem(
                                  "product",
                                  product.info.avb_product_for_order__id,
                                  1,
                                  product.info.price
                                );
                              }}
                            >
                              <BsPlus
                                color="red"
                                style={{ fontSize: "25px" }}
                                className="icon"
                              />
                            </button>

                            <span className="mx-1">
                              {getCount(
                                product.info.avb_product_for_order__id,
                                "product"
                              )}
                            </span>
                            <button
                              className="btn shadow rounded cartBtn d-flex justify-content-center align-items-center"
                              // onClick={onDecrease}
                              onClick={() => {
                                reduceCartItem(
                                  "product",
                                  product.info.avb_product_for_order__id
                                );
                              }}
                            >
                              {getCount(
                                product.info.avb_product_for_order__id,
                                "product"
                              ) ==
                              (product.info.min_order_count != "0"
                                ? product.info.min_order_count
                                : "1") ? (
                                <BsTrash
                                  color="red"
                                  className="icon"
                                  style={{ fontSize: "20px" }}
                                />
                              ) : (
                                <BiMinus
                                  color="red"
                                  className="icon"
                                  style={{ fontSize: "20px" }}
                                  // onClick={() => {
                                  //   reduceCartItem(
                                  //     "product",
                                  //     product.info.avb_product_for_order__id
                                  //   );
                                  // }}
                                />
                              )}
                            </button>
                          </>
                        )}
                        {/* <div style={{ color: "red", fontSize: "12px" }} className="mt-1">
              {data.apo_info.min_order_count != "0" &&
                `حداقل تعداد سفارش : ${data.apo_info.min_order_count}`}
            </div> */}
                      </div>
                      {/* <div style={{ whiteSpace: "nowrap" }}>
                        <button
                          type="button"
                          className="btn btn-primary shopBtn mt-3"
                          onClick={addCart}
                        >
                          افزودن به سبد خرید
                        </button>
                      </div> */}
                    </div>
                  </div>

                  {/* <div className="mx-3 mt-5 shadow rounded-10 p-4">
                    <div className="d-flex justify-content-between  align-items-center send-comment">
                      <h6 className="fs-14 ">
                        لطفا نظر و دیدگاه خود را نسبت به کالای موردنظر بنویسید
                      </h6>
                      <div className="">
                        
                        <Rate
                          direction="rtl"
                          style={{ fontSize: "30px" }}
                          defaultValue={3}
                          // allowHalf={true}
                          value={sendComment.rating}
                          onChange={e => {
                            changeHandler(e, "rating");
                          }}
                        ></Rate>
                      </div>
                    </div>
                    <textarea
                      className="form-control"
                      style={{ height: "100px" }}
                      value={sendComment.txt}
                      onChange={e => {
                        changeHandler(e.target.value, "txt");
                      }}
                    ></textarea>
                    <div className="text-end mx-3 mt-3">
                      <button
                        className="btn btn-success px-3"
                        onClick={() => {
                          isLogged
                            ? insertComment()
                            : toast.error("ابتدا وارد حساب کاربری شوید");
                          document.querySelector("#exampleModal").modal("show");
                        }}
                      >
                        {" "}
                        ثبت نظر
                      </button>
                    </div>
                  </div> */}
                  {data ? (
                    <Formatter color={"#5a3eff"} header="محصولات مشابه">
                      <div className="sliderContainer">
                        <Swiper
                          navigation={true}
                          modules={[Navigation, Pagination]}
                          spaceBetween={15}
                          pagination={{
                            clickable: true,
                          }}
                          breakpoints={{
                            slidesPerView: 1,
                            spaceBetween: 10,
                            380: {
                              slidesPerView: 1.5,
                            },
                            450: {
                              slidesPerView: 2,
                            },
                            600: {
                              slidesPerView: 2,
                              spaceBetween: 5,
                            },
                            850: {
                              slidesPerView: 3,
                              spaceBetween: 2,
                            },
                            1200: {
                              slidesPerView: 4,
                            },
                            1550: {
                              slidesPerView: 5,
                            },
                            1700: {
                              slidesPerView: 6,
                              spaceBetween: 15,
                            },
                          }}
                          className="mySwiper SinglePartition"
                        >
                          {data != undefined && data.length > 0 ? (
                            <div>
                              {data.map((value, index) => {
                                return (
                                  <SwiperSlide key={index}>
                                    <div
                                      onClick={() => {
                                        setSimilarProductShouldChange(false);
                                        // changeMainProduct(value);
                                      }}
                                    >
                                      <SinglePartitionNew
                                        value={value}
                                        type={type}
                                        setProduct={setProduct}
                                        shouldCloseModal={false}
                                      ></SinglePartitionNew>
                                    </div>
                                  </SwiperSlide>
                                );
                              })}
                            </div>
                          ) : null}
                        </Swiper>
                      </div>
                    </Formatter>
                  ) : (
                    ""
                  )}

                  {/* <div className="mt-5">
                    {data ? (
                      <Formatter color={"#5a3eff"} header="محصولات مشابه">
                        <div className="parent-singlePartion ">
                          <SinglePartition type="similarProduct" data={data} />
                        </div>
                      </Formatter>
                    ) : (
                      ""
                    )}
                  </div> */}

                  {comments && (
                    <Formatter color={"#1C2140"} header={"نظرات کاربران"}>
                      <Comments
                        commentUpdater={commentUpdater}
                        setCommentUpdater={setCommentUpdater}
                        isProduct
                      />
                    </Formatter>
                  )}
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default SingleProduct;
